import { useEffect } from 'react';
import useAppContext from '../../context/useAppContext';

/**
 * A quick and dirty way to update the title of the document for any page anywhere.
 * Looks for a nacre header on the page that has a set title, and uses that as the header of the page.
 * A "better" way would be to have a React hook that updates the page title. But that would require a huge PR
 * touching every component in the app. Some title are computed in sub-components. We could watch for location
 * change instead of the interval, but ofter the title only renders after the page has fully loaded.
 */
export function usePageTitleUpdater() {
    // The organization can but null while the page is loading
    const organizationId = useAppContext()[0].organization?.id;
    useEffect(() => {
        const intervalId = setInterval(() => {
            const title = document.querySelector('.wz-titleheader')?.textContent || 'WeezTicket';
            document.title = organizationId ? `O${organizationId} • ${title}` : title;
        }, 500);
        return () => clearInterval(intervalId);
    }, [organizationId]);
}
